module.exports = __webpack_public_path__ + "static/media/person_with_lines.4335c8ba.jpg";